// Weekend-work map keys for the template editor. TemplateEditor shows tasks
// from several templates at once (main + attached add-in pools) and ST# ids
// can collide across them, so the map is keyed by owning template AND task.
const weekendWorkKey = (projectId, taskId) => `${projectId}:${String(taskId)}`;

// Build the map TemplateGantt consumes from combined subtask rows.
const buildTemplateWeekendWorkMap = (subtasks) => {
    const map = {};
    for (const st of subtasks || []) {
        if (st.weekendDatesWorked && Object.keys(st.weekendDatesWorked).length > 0) {
            map[weekendWorkKey(st.projectId, st.taskId)] = st.weekendDatesWorked;
        }
    }
    return map;
};

export { weekendWorkKey, buildTemplateWeekendWorkMap };
